import { render } from "./AdminEditAgency.vue?vue&type=template&id=46887c80&lang=pug"
import script from "./AdminEditAgency.vue?vue&type=script&lang=js"
export * from "./AdminEditAgency.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__